import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { Path, RoutePath } from 'src/app/shared/route';

@Component({
  templateUrl: './mobile-menu.component.html',
  standalone: true,
  selector: 'app-mobile-menu',
  imports: [RouterLink, MatButtonModule, MatIconModule, MatMenuModule],
})
export class MobileMenuComponent {
  readonly termRoute = RoutePath.getPath(Path['terms-and-conditions']).fullPath;
  readonly privacyRoute = RoutePath.getPath(Path['privacy-policy']).fullPath;
  readonly aboutRoute = RoutePath.getPath(Path['about-us']).fullPath;
  readonly contactRoute = RoutePath.getPath(Path['contact-us']).fullPath;
}
